import {ClientId, FromServerId} from 'notebook/ELNConstants';
import {Format} from 'notebook/mediocre/formatted-text/FormattersConstants';

export const LEVEL_MATERIAL = 'MATERIAL';
export const LEVEL_COMPONENT = 'COMPONENT';

export type BaseMaterial<TIds> = {
  components: Array<BaseComponent<TIds>>;
  creator_id: number;
  name: string;
  formats: Format;
  link_type: string;
} & TIds;

type BaseComponent<TIds> = {
  raw_text: string;
  formats: Format;
} & TIds;

export type Material = BaseMaterial<ClientId>;
export type Component = BaseComponent<ClientId>;
export type FromServerComponent = BaseComponent<FromServerId>;
